import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataFetched ? _c('div', {
    staticClass: "card-form container"
  }, [_c('b-row', {
    staticClass: "mb-5 w-100 d-flex justify-content-around",
    style: _vm.cardStyle
  }, [_c('img', {
    staticClass: "max-h-80px",
    attrs: {
      "alt": "Logo",
      "src": _vm.emissor.logo
    }
  }), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.emissor.nome) + " - " + _vm._s(_vm.emissor.telefone))]), _vm._v(" "), _c('br'), _vm.emissor.cnpj_cpf.length < 14 ? _c('span', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _vm.emissor.cnpj_cpf.length >= 14 ? _c('span', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.emissor.cnpj_cpf)))]) : _vm._e(), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.logradouro, " - ").concat(_vm.emissor.numero, " - ").concat(_vm.emissor.bairro, ", ").concat(_vm.emissor.cep)))]), _c('br'), _c('span', [_vm._v(_vm._s("".concat(_vm.emissor.cidade, " - ").concat(_vm.emissor.uf)))]), _c('br')])]), _c('strong', [_vm._v("Ordem de Compra: ")]), _c('span', [_vm._v(" " + _vm._s(_vm.numero) + " ")]), _c('div', [_c('div', [_c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Fornecedor",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Nome: ")]), _vm._v(_vm._s(_vm.fornecedor.nome)), _c('br'), _vm.fornecedor.cnpj_cpf !== null && _vm.fornecedor.cnpj_cpf.length < 14 ? _c('strong', [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(_vm.fornecedor.cnpj_cpf)) + " "), _c('br')]) : _vm._e(), _vm.fornecedor.cnpj_cpf !== null && _vm.fornecedor.cnpj_cpf.length >= 14 ? _c('strong', [_vm._v("CNPJ: " + _vm._s(_vm.formatCpfCnpj(_vm.fornecedor.cnpj_cpf))), _c('br')]) : _vm._e(), _vm.fornecedor.telefone ? _c('strong', [_vm._v("Telefone:")]) : _vm._e(), _vm._v(_vm._s(_vm.fornecedor.telefone)), _c('br'), _vm.fornecedor.cep ? _c('div', {
    staticStyle: {
      "white-space": "normal"
    }
  }, [_c('strong', [_vm._v("Endereço: ")]), _vm._v(" " + _vm._s(_vm.fornecedor.logradouro) + ", " + _vm._s(_vm.fornecedor.numero) + "," + _vm._s(_vm.fornecedor.bairro) + "," + _vm._s(_vm.fornecedor.complemento) + " " + _vm._s(_vm.fornecedor.cep) + "," + _vm._s(_vm.fornecedor.cidade) + "-" + _vm._s(_vm.fornecedor.uf) + " ")]) : _vm._e()])], 1), _c('b-card', {
    staticClass: "mb-2 border border-primary",
    attrs: {
      "title": "Produtos",
      "tag": "article"
    }
  }, [_c('b-card-text', [_vm.produtos.length > 0 ? _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "items": _vm.tableItems
    },
    scopedSlots: _vm._u([{
      key: "row-details",
      fn: function fn(row) {
        return [_vm.getProdutoObservacao(row) ? _c('b-row', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_c('b-col', [_vm._v("Observacao: " + _vm._s(_vm.getProdutoObservacao(row)) + " ")])], 1) : _vm._e()];
      }
    }], null, false, 1937749499)
  }) : _vm._e()], 1)], 1), _c('b-card', {
    staticClass: "mb-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Pagamentos",
      "tag": "article"
    }
  }, _vm._l(_vm.pagamentos, function (pagamento, index) {
    return _c('b-card-text', {
      key: pagamento.descricao
    }, [_c('label', [_vm._v(_vm._s(pagamento.paymentMode.name))]), _vm.produtos.length > 0 ? _c('b-table', {
      attrs: {
        "striped": "",
        "small": "",
        "fixed": "",
        "hover": "",
        "items": _vm.tablePagamentoItems(index)
      }
    }) : _vm._e()], 1);
  }), 1), _c('b-card', {
    staticClass: "my-2 border border-primary",
    style: _vm.cardStyle,
    attrs: {
      "title": "Outras informaçoes",
      "tag": "article"
    }
  }, [_c('b-card-text', [_c('strong', [_vm._v("Observação: ")]), _vm._v(" " + _vm._s(_vm.observacao) + " "), _c('br'), _c('strong', [_vm._v("Data Solicitação: ")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.data_solicitacao, "DD/MM/YYYY")) + " "), _c('br'), _c('strong', [_vm._v("Total da Ordem R$: ")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.valorTotal, 2)) + " ")])], 1)], 1)]), _c('div', {
    staticClass: "mt-5 w-100 d-flex justify-content-end"
  }, [_c('img', {
    staticClass: "max-h-60px mr-5",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.secundary')
    }
  })])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };